<template>
  <div class="container-fluid">
    <vx-card :title="'Variables / Modelo de Aprobación'">
      <div class="row">
        <div class="col-md-12">
          <vs-table :data="[{}]" v-if="formError === ''">
            <vs-tr>
              <vs-td class="font-bold">PID</vs-td>
              <vs-td class="text-right">{{ request.project_id }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Rfc del cliente</vs-td>
              <vs-td class="text-right">{{ result.rfc }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Edad</vs-td>
              <vs-td class="text-right">{{ result.age }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Ahorro anual</vs-td>
              <vs-td class="text-right">{{ result.financials.annual_savings|currency }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Dependientes económicos</vs-td>
              <vs-td class="text-right">{{ result.economic_dependents }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Total de la factura</vs-td>
              <vs-td class="text-right">{{ result.financials.total_cost|currency }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Monto a financiar</vs-td>
              <vs-td class="text-right">{{ result.financials.financed_amount|currency }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Mensualidad</vs-td>
              <vs-td class="text-right">{{ result.financials.monthly_payment|currency }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Meses</vs-td>
              <vs-td class="text-right">{{ result.financials.term }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Antiguedad del empleo</vs-td>
              <vs-td class="text-right">{{ result.job_age }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Es propietario</vs-td>
              <vs-td class="text-right">{{ result.is_property_ownership|answerBoolean }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Documento de propiedad</vs-td>
              <vs-td class="text-right">{{ result.property_document }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Domiciliación</vs-td>
              <vs-td class="text-right">{{ result.has_domiciliation|answerBoolean }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Comprobante de ingresos</vs-td>
              <vs-td class="text-right">{{ result.source_of_income_document }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Propiedades del cliente</vs-td>
              <vs-td class="text-right">{{ result.real_estate_assets|answerBoolean }}</vs-td>
            </vs-tr>
            <vs-tr v-if="false">
              <vs-td class="font-bold">Giro de la empresa</vs-td>
              <vs-td class="text-right">{{ result.company_activity }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Nivel de empleo</vs-td>
              <vs-td class="text-right">{{ result.employment_level }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Nivel de estudios</vs-td>
              <vs-td class="text-right">{{ result.educational_level }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Estado civil</vs-td>
              <vs-td class="text-right">{{ result.marital_status }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Presencia Judicial</vs-td>
              <vs-td class="text-right">{{ result.project_state }}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">Inseguridad</vs-td>
              <vs-td class="text-right">{{ result.project_city }}</vs-td>
            </vs-tr>
          </vs-table>

          <vs-alert v-else color="danger">{{formError}}</vs-alert>

        </div>
      </div>
      <!--<div class="row">
        <div class="col-md-12">
          <vs-button @click="buildSchema()">Schema</vs-button>
        </div>
      </div>-->
    </vx-card>
  </div>
</template>

<script>
import {fixNumber} from "@/filters/NumberFilters";
import {mapState} from "vuex";

export default {
  name: "ApproveModelRiskForm",
  props: {
    schema: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState("projects", ["project"])
  },
  data: () => ({
    result: {},
    formError: "",
    request: {
      project_id: 0,
      rfc: "",
      average_income_1: 0,
      average_income_2: 0,
      average_income_3: 0,
    }
  }),
  async mounted() {
    let projectId = this.$route.params.id;
    this.rfc = this.project.client.fiscal.rfc;

    this.$vs.loading();

    try {
      const {data} = await axios.post(`/api/risk-model/approve/form`, {
        projectId: projectId,
        fiscalProfileId: this.project.client.fiscal.id,
        type: this.type
      });
      this.result = data;
    } catch (e) {
      this.formError = e.response.data.error
    } finally {
      this.$vs.loading.close();
    }
  },
  filters: {
    fixNumber,
    answerBoolean(val) {
      return val ? 'Sí': 'No';
    }
  },
  methods: {
    async buildSchema() {
      this.$vs.loading();
      this.projectId = this.$route.params.id;

      try {
        const {data} = await axios.post(`/api/risk-model/${this.projectId}/approve/build`, this.result)
        this.$emit("update:schema", data);
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>
